export default function PrinciplesSection() {
  return (
    <section className="py-24 md:py-32 px-8 md:px-16 bg-background-100">
      <div className="max-w-5xl mx-auto">
        {/* Top area */}
        <div className="flex flex-col">
          {/* Small identifier */}
          <span className="font-sans text-xs md:text-sm uppercase tracking-[0.3em] text-foreground-400 font-light leading-relaxed">
            pr<br />nc
          </span>

          {/* Large serif title */}
          <h2 className="mt-8 font-heading text-4xl md:text-6xl lg:text-[64px] font-bold text-foreground-900 leading-[1.1]">
            Engineering<br />Principles
          </h2>
        </div>

        {/* Card area */}
        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Left card - dark */}
          <div className="bg-foreground-900 rounded-2xl p-8 md:p-10 flex flex-col justify-between min-h-[380px]">
            <div className="w-10 h-10 rounded-full bg-foreground-700 flex items-center justify-center">
              <span className="font-sans font-bold text-sm text-foreground-100">A</span>
            </div>
            <div className="flex-1 flex flex-col justify-end mt-8">
              <p className="font-sans text-xl md:text-2xl font-semibold text-background-50 leading-tight">
                Clean architecture with separation of concerns
              </p>
              <p className="mt-4 text-sm text-foreground-300 font-body leading-relaxed">
                Modular, testable, and maintainable codebases that scale with confidence
              </p>
            </div>
          </div>

          {/* Middle card - abstract gradient background */}
          <div
            className="rounded-2xl p-8 md:p-10 flex flex-col justify-between min-h-[380px] relative overflow-hidden"
            style={{
              background: 'linear-gradient(160deg, oklch(0.58 0.13 35 / 0.7), oklch(0.54 0.16 25 / 0.5), oklch(0.72 0.04 82 / 0.4))',
            }}
          >
            {/* Subtle pattern overlay */}
            <div className="absolute inset-0 opacity-10"
              style={{
                backgroundImage: 'radial-gradient(circle at 20% 30%, oklch(0.93 0.025 84 / 0.5) 1px, transparent 1px)',
                backgroundSize: '24px 24px',
              }}
            />
            <div className="relative z-10">
              <div className="inline-block bg-background-50/20 backdrop-blur-sm px-4 py-2 rounded-full">
                <span className="font-sans text-xs font-medium text-background-50 tracking-wide">
                  core value
                </span>
              </div>
            </div>
            <div className="relative z-10 flex-1 flex flex-col justify-end mt-8">
              <p className="font-sans text-xl md:text-2xl font-semibold text-background-50 leading-tight">
                Performance optimization at every layer
              </p>
              <p className="mt-4 text-sm text-background-50/70 font-body leading-relaxed">
                Fast, responsive systems built with efficiency from the ground up
              </p>
            </div>
          </div>

          {/* Right card - light */}
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 flex flex-col min-h-[380px]">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 leading-tight">
              User-Centered<br />Design
            </h3>
            <p className="mt-3 text-sm text-foreground-500 font-body leading-relaxed">
              Every interface decision starts with the people who will use it
            </p>
            {/* Abstract geometric image area */}
            <div className="mt-auto pt-6 flex-1 min-h-[120px] flex items-end">
              <div className="w-full h-32 md:h-40 rounded-xl relative overflow-hidden"
                style={{ backgroundColor: 'oklch(0.96 0.012 92 / 0.5)' }}>
                {/* Abstract floating shapes */}
                <div className="absolute top-4 right-6 w-12 h-12 rounded-lg opacity-30"
                  style={{ background: 'linear-gradient(135deg, oklch(0.54 0.16 25 / 0.5), oklch(0.58 0.13 35 / 0.4))' }}
                />
                <div className="absolute bottom-3 left-4 w-16 h-10 rounded-full opacity-25"
                  style={{ background: 'linear-gradient(90deg, oklch(0.72 0.04 82 / 0.6), oklch(0.93 0.025 84 / 0.3))' }}
                />
                <div className="absolute top-8 left-10 w-8 h-8 rounded-full opacity-20 bg-accent-400/60" />
                <div className="absolute bottom-6 right-10 w-10 h-6 rounded-md opacity-20 bg-primary-400/50" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}